<template>
  <td>{{ game }}</td>
</template>

<script>
  export default {
    name: "TableBlueLabelGame",
    props: ['game']
  }
</script>

<style scoped>
  td {
    text-align: center !important;
  }
</style>
